import { Box, CssBaseline, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Sidebar from "./components/Sidebar";
import { Typography } from "@mui/material";

const useStyles = makeStyles({
    root: {
        height: "100vh",
        padding: "0px",
        margin: "0px",
        backgroundColor: "#F6F9FF",
        boxSizing: "border-box",
    },
    dashboard: {
        margin: "0px",
        padding: "0px",
        width: "100%",
        height: "100%",
        borderRadius: "0px",
        overflow: "hidden",
    },
    text: {
        margin: "0px",
        padding: "0px",
        color: "#111111",
    },
    list: {
        borderRadius: "20px",
        border: "none",
        backgroundColor: "#FFFFFF",
        height: "400px", // to be removed
        minHeight: "100%",
        padding: "20px",
    },
});

const Dashboard = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Grid container className={classes.root}>
                <Grid item xs={2}>
                    <Box className={classes.dashboard}>
                        <Sidebar />
                    </Box>
                </Grid>
                <Grid item xs={10}>
                    <Box className={classes.dashboard}>
                        <Box mt={7} ml={10}>
                            <h1 className={classes.text}>Network Computers</h1>
                        </Box>
                        <Box m={10}>
                            <Box className={classes.list}>
                                <Typography variant="h6" component="h6">
                                    List of computers
                                </Typography>
                            </Box>
                            <Box />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
};

export default Dashboard;
